import { ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import BankPosAccount from '../entities/finance/bankPosAccount';
import Ajax from '../../lib/ajax';

interface BankPosAccountState extends ListState<BankPosAccount> {
  editBankPosAccount: BankPosAccount;
}

class BankPosAccountModule extends ListModule<BankPosAccountState, any, BankPosAccount> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<BankPosAccount>(),
    loading: false,
    editBankPosAccount: new BankPosAccount(),
  };

  actions = {
    async getAllBankPosAccounts(context: ActionContext<BankPosAccountState, any>) {
      context.state.loading = true;
      let response = await Ajax.get('/api/services/app/Admin/GetAllBankPosAccounts');
      context.state.loading = false;
      context.state.list = response.data.result.items;
      context.state.totalCount = response.data.result.items.length;
    },

    async editBankPosAccount(context: ActionContext<BankPosAccountState, any>, payload: any) {
      await Ajax.post('/api/services/app/Admin/EditBankPosAccount', payload.data);
    },
  };

  mutations = {
    setCurrentPage(state: BankPosAccountState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: BankPosAccountState, pagesize: number) {
      state.pageSize = pagesize;
    },
    setEditBankPosAccount(state: BankPosAccountState, bankPosAccount: BankPosAccount) {
      state.editBankPosAccount = bankPosAccount;
    },
  };
}

const bankPosAccountModule = new BankPosAccountModule();
export default bankPosAccountModule;
